export default __webpack_public_path__ + "media/images/celeste_dark_sit-59902de6a1a120e42f2a5087f94d8c89.png";